let TRESHOLD_TO_SCROLL_TO_HIDE_SHOW_HEADER = 200;

jQuery(document).ready(function ($) {
    var contentPlacement = $('#header').position().top + $('#header').height();
    $('#main').css('margin-top', contentPlacement);

    if (window.innerWidth < 992) {
        let previousScroll = 0;
        let scroll_direction_down = false;
        $(window).scroll(function () {
            let currentScroll = $(this).scrollTop();
            // If the current scroll position is greater than 0 (the top)
            // AND the current scroll position is less than the document height minus the window height (the bottom)
            // run the navigation if/else statement.
            if (currentScroll > 0 && currentScroll < $(document).height() - $(window).height()) {
                // If the current scroll is greater than the previous scroll (i.e we're scrolling down the page), hide the nav.
                if (currentScroll > previousScroll + TRESHOLD_TO_SCROLL_TO_HIDE_SHOW_HEADER) {
                    window.setTimeout(hideHeader, 100);
                    // Else we are scrolling up (i.e the previous scroll is greater than the current scroll), so show the nav.
                    previousScroll = currentScroll;
                    scroll_direction_down = true;
                } else if (currentScroll < previousScroll - TRESHOLD_TO_SCROLL_TO_HIDE_SHOW_HEADER) {
                    window.setTimeout(showHeader, 100);
                    previousScroll = currentScroll;
                    scroll_direction_down = false;
                }

                //update previousScroll all the time if the direction is the same
                if (scroll_direction_down && currentScroll > previousScroll) {
                    previousScroll = currentScroll;
                } else if (!scroll_direction_down && currentScroll < previousScroll) {
                    previousScroll = currentScroll;
                }
            }
        });
    }

    function hideHeader() {
        $(".mobile-search-container").addClass('fade-out');
    }

    function showHeader() {
        $(".mobile-search-container").removeClass('fade-out');
    }
});
